import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getCookie } from '../utils/get-cookie';

@Injectable({
  providedIn: 'root',
})
export class GoalsService {
  token: string = '';
  constructor(public httpClient: HttpClient) {
    this.token = getCookie('token');
  }

  getGoals(formsId: number) {
    return this.httpClient.get(
      `${environment.api_guia}forms/${formsId}/goals`,
      {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  }
  getSelectedGoals(formsId: number) {
    return this.httpClient.get(
      `${environment.api_guia}forms/${formsId}/selectedGoals`,
      {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  }

  createGoals(formsId: number, goalsId: number[]) {
    return this.httpClient.post(
      `${environment.api_guia}forms/${formsId}/goals`,
      { individuals_goals_ids: goalsId },
      {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  }

  updateGoals(formsId: number, goalId: number, goalData: any){
    return this.httpClient.patch(
      `${environment.api_guia}forms/${formsId}/goals/${goalId}`,
      goalData,
      {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  }
}
